function __rspack_empty_async_context(req) {
  // Here Promise.resolve().then() is used instead of new Promise() to prevent
  // uncaught exception popping up in devtools
  return Promise.resolve().then(function() {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  });
}
__rspack_empty_async_context.keys = () => ([]);
__rspack_empty_async_context.resolve = __rspack_empty_async_context;
__rspack_empty_async_context.id = "ltR";
module.exports = __rspack_empty_async_context;
